export const initialValues = (responseData) => {
  const { data } = responseData;

  return {
    property_id: data.property_id || "",
    property_details: {
      logo: data.property_details?.logo || "",
      partnership_label: data.property_details?.partnership_label || "",
      landlord: data.property_details?.landlord || "",
      utilities_available: {
        electricity: Boolean(data.property_details?.utilities_available?.electricity ?? true),
        heat: Boolean(data.property_details?.utilities_available?.heat ?? true),
        water_waste: Boolean(data.property_details?.utilities_available?.water_waste ?? true),
      },
      utilities_paid_by_tenant: {
        electricity: Boolean(data.property_details?.utilities_paid_by_tenant?.electricity ?? false),
        heat: Boolean(data.property_details?.utilities_paid_by_tenant?.heat ?? false),
        water_waste: Boolean(data.property_details?.utilities_paid_by_tenant?.water_waste ?? false),
      },
      custom_utilities_clause: data.property_details?.custom_utilities_clause ?? "",
      allowed_pets: {
        dogs: Boolean(data.property_details?.allowed_pets?.dogs ?? true),
        cats: Boolean(data.property_details?.allowed_pets?.cats ?? true),
        others: Boolean(data.property_details?.allowed_pets?.others ?? true),
      },
      pet_fees: {
        cat_fee: Number(data.property_details?.pet_fees?.cat_fee ?? 35),
        dog_fee: Number(data.property_details?.pet_fees?.dog_fee ?? 50),
        other_fee: Number(data.property_details?.pet_fees?.other_fee ?? 80),
      },
      property_name: data.property_details?.property_name || "",
      building_name: data.property_details?.building_name || "",
      unit_no: data.property_details?.unit_no || "",
      address: data.property_details?.address || "",
      city: data.property_details?.city || "",
      province: data.property_details?.province || "",
      postal_code: data.property_details?.postal_code || "",
      incentives: data.property_details?.incentives || "",
      appliances: data.property_details?.appliances || [],
    },
    manager: {
      first_name: data.manager?.first_name || "",
      last_name: data.manager?.last_name || "",
      phone_no: data.manager?.phone_no || "",
      email: data.manager?.email || "",
      signature: data.manager?.signature || "",
      date: data.manager?.date || "",
    },
    tenants: data.tenants?.map(tenant => ({
      id: tenant.id || "",
      name: tenant.name || "",
      email: tenant.email || "",
      signature: tenant.signature || "",
      date: tenant.date || "",
      initials: tenant.initials || "",
      initialed_pages: tenant.initialed_pages || [],
    })) || [],
    occupants: data.occupants?.map(occupant => ({
      name: occupant.name || "",
      relationship: occupant.relationship || "",
      age: occupant.age || "",
    })) || [],
    lease_details: {
      start_date: data.lease_details?.start_date || null,
      end_date: data.lease_details?.end_date || null,
      basic_rent: data.lease_details?.basic_rent || "",
      pets: data.lease_details?.pets?.map(pet => ({
        category: pet.category || "",
        total_fee: Number(pet.total_fee) || 0,
        no_of_pets: Number(pet.no_of_pets) || 0,
      })) || [],
      parking: data.lease_details?.parking?.map(parking => ({
        parking_type: parking.parking_type || "",
        total_fee: Number(parking.total_fee) || 0,
        no_of_slots: Number(parking.no_of_slots) || 0,
      })) || [],
      storage: data.lease_details?.storage?.map(storage => ({
        total_fee: Number(storage.total_fee) || 0,
        no_of_slots: Number(storage.no_of_slots) || 0,
      })) || [],
      pro_ration: {
        date_of_early_move_in: data.lease_details?.pro_ration?.date_of_early_move_in || "",
        amount_applicable: Number(data.lease_details?.pro_ration?.amount_applicable) || 0,
        amount_to_be_charged: Number(data.lease_details?.pro_ration?.amount_to_be_charged) || 0,
      },
      telus: {
        included: Boolean(data.lease_details?.telus?.included ?? false),
        charges: String(data.lease_details?.telus?.charges ?? ""),
      },
      utilities: {
        heat_fee: Number(data.lease_details?.utilities?.heat_fee) || 0,
        water_waste_fee: Number(data.lease_details?.utilities?.water_waste_fee) || 0,
        electricity_fee: Number(data.lease_details?.utilities?.electricity_fee) || 0,
      },
      incentives: data.lease_details?.incentives || "",
    },
    security_deposits: {
      refundable: data.security_deposits?.refundable || "",
      non_refundable: data.security_deposits?.non_refundable || "",
      received_date: data.security_deposits?.received_date || "",
    },
    attached_documents: data.attached_documents?.map(doc => ({
      id: doc.id || "",
      name: doc.name || "",
      urls: doc.urls?.map(url => ({
        file_url: url.file_url || "",
        uploaded_by: url.uploaded_by || "Default Document",
        uploaded_at: url.uploaded_at || new Date(),
      })) || [],
      send_to_users: doc.send_to_users?.map(user => ({
        id: user.id || "",
      })) || [],
      signature_required_from: doc.signature_required_from?.map(user => ({
        id: user.id || "",
      })) || [],
      signatures: doc.signatures?.map(sig => ({
        id: sig.id || "",
        name: sig.name || "",
        signature: sig.signature || "",
        date: sig.date || "",
      })) || [],
    })) || [],
    additional_notes: data.additional_notes || "",
    lease_status: {
      state: data.lease_status?.state,
      effective_date: data.lease_status?.effective_date || new Date(),
      end_reason: data.lease_status?.end_reason || "",
      notes: data.lease_status?.notes || "",
    },
    version_info: {
      version_number: Number(data.version_info?.version_number) || 1,
      previous_lease_id: data.version_info?.previous_lease_id || null,
      is_renewal: Boolean(data.version_info?.is_renewal ?? false),
      is_amendment: Boolean(data.version_info?.is_amendment ?? false),
      original_lease_id: data.version_info?.original_lease_id || null,
    },
    audit_trail: data.audit_trail?.map(audit => ({
      action: audit.action || "",
      timestamp: audit.timestamp || new Date(),
      user_id: audit.user_id || null,
      details: audit.details || {},
    })) || [],
    isActive: Boolean(data.isActive ?? false),
    isInprogress: Boolean(data.isInprogress ?? true),
    createdAt: data.createdAt || '',
  };
};